import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerOtrosTramites = styled(motion.div)`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 25px;
  padding-bottom: 30px;

  @media (max-height: 700px) {
    padding-top: 20px;
  }
`;

export const TextOtrosTramites = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;

  .title-saludo {
    font-weight: 400;
    font-size: 22px;
    line-height: 150%;
    text-align: center;
    max-width: 365px;
    padding: 0 20px;
  }

  .title-pregunta {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    text-align: center;
    max-width: 365px;
  }

  .title-negrita {
    font-weight: bold;
  }

  @media (max-height: 700px) {
    margin-bottom: 15px;

    .title-saludo {
      font-size: 20px;
    }
  }
`;

export const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;

  svg {
    width: 25px;
    height: 25px;
  }

  @media (max-height: 700px) {
    gap: 14px;
  }

  @media (max-height: 600px) {
    gap: 12px;
  }
`;

export const HeaderHomeBar = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  margin: auto;
  color: var(--color-white);
  background-color: var(--color-latex10);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-top: 4px solid var(--color-primary);

  .title {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }
  .title-negrita {
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }

  h1 {
    padding: 0;
    margin: 0;
    text-align: center;
  }
  .container-ellipse {
    width: 100%;
    height: max-content;
    /* background-color: red; */
    position: absolute;
    bottom: -50%;
    margin: auto;
    right: 0;
  }

  ::after {
    content: "";
    position: absolute;
    width: 150%;
    height: 50px;
    bottom: -25px;
    z-index: -1;
    border-radius: 50%;
    background-color: var(--color-latex10);
  }
`;
